<template>
  <div class="full-width">
    <div v-if="img" class="row justify-center q-mb-sm">
      <QImg
        class="col-xs-8 col-sm-6 col-md-5 col-lg-4"
        :src="img"
        basic
        contain
        alt="Adjust budget"
      />
    </div>
    <div class="row q-pb-sm" v-for="(budget, index) in budgets" :key="index">
      <div class="col">
        <div class="row items-center">
          <QIcon
            color="primary"
            :name="budget.icon"
            size="md"
            v-if="budget.icon"
          />
          <div class="column q-ml-md col">
            <div class="row items-center">
              <span v-if="budget.label">{{ budget.label }}</span>
              <SAIInformationPopup v-if="budget.information" class="q-ml-xs">
                <p>{{ budget.information }}</p>
              </SAIInformationPopup>
            </div>
            <span class="text-primary text-lowercase">
              {{ budget.value | frequency('monthly', 'yearly') | currency }}
              / year
            </span>
          </div>
        </div>
      </div>
      <div class="col-4">
        <SAIInput
          :disable="disable"
          prefix="$"
          type="number"
          :value="
            budget.value
              | frequency('monthly', frequency)
              | RoundDecimalFilter(2)
          "
          @input="$emit('input', { type: budget.type, value: $event })"
        />
      </div>
    </div>
    <div class="q-pt-lg row justify-between items-center">
      <div class="column col q-pr-sm">
        <p class="text-weight-medium text-grey-10 word-break-word">
          ESTIMATED TOTAL RUNNING COSTS
        </p>
        <span class="text-primary text-lowercase">
          {{ total | frequency('monthly', 'yearly') | currency }}
          / year
        </span>
      </div>
      <h3 class="text-weight-medium text-grey-10">
        {{ total | frequency('monthly', frequency) | currency }}
      </h3>
    </div>
  </div>
</template>

<script>
import { QIcon, QImg } from 'quasar';
import {
  SAIInput,
  SAIInformationPopup,
  RoundDecimalFilter
} from 'ecx.saigon.ui.common';

export default {
  name: 'BudgetRunningCosts',
  props: {
    img: String,
    budgets: {
      type: Array,
      default: () => []
    },
    disable: Boolean,
    frequency: {
      type: String,
      required: true
    }
  },
  computed: {
    total() {
      return this.budgets.reduce((currentVal, iterate) => {
        let increment = Boolean(iterate.value) ? Number(iterate.value) : 0;
        return currentVal + increment;
      }, 0);
    }
  },
  filters: {
    RoundDecimalFilter
  },
  components: {
    QImg,
    SAIInput,
    QIcon,
    SAIInformationPopup
  }
};
</script>
